import { makeBetterEnum } from './betterEnum';

export const UserUploadStatus = makeBetterEnum(
  'Uploading',
  'Uploaded',
  'Processing',
  'Processed',
  'Validated',
  'Errored',
  'Finalized'
);
export type UserUploadStatus =
  (typeof UserUploadStatus)[keyof typeof UserUploadStatus];

export const UserUploadProcessingMode = makeBetterEnum(
  'Legacy',
  'Synchronous',
  'NoProcessing',
  'IdiRawFile',
  'Api'
);
export type UserUploadProcessingMode =
  (typeof UserUploadProcessingMode)[keyof typeof UserUploadProcessingMode];

////////////////////////////////////////////////////
// Types of file upload sources (with overlap)
////////////////////////////////////////////////////

export const UserUploadCandidateKind = makeBetterEnum(
  'Api',
  'Document',
  'File',
  'Form',
  'Integration',
  'Manual'
);
export type UserUploadCandidateKind =
  (typeof UserUploadCandidateKind)[keyof typeof UserUploadCandidateKind];

export const UserUploadSource = makeBetterEnum('InProduct', 'PublicAPI');
export type UserUploadSource =
  (typeof UserUploadSource)[keyof typeof UserUploadSource];
